import React, {Component} from "react";
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon} from "reactstrap";
import { connect } from 'react-redux'
import { userFetchData } from '../../actions/user';
import Spinner from '../../components/FormComponents/Spinner'

class Login extends Component {

  constructor(props, context) {
      super(props, context);
      this.state = {
            postData: {'host': this.props.clientPath.clientPath}
        }
      this.handleSubmit = this.handleSubmit.bind(this); 
  }

  handleSubmit(e) {
      e.preventDefault();                
      this.props.fetchData(this.props.clientPath.clientPath + '/api/user/action/login', this.state.postData);      
  }


  setInputState(e) {        
     
      this.setState({
          postData: {...this.state.postData, [e.target.name]: e.target.value }

      });   
     

  }

  render() {    
    return (
      <div className="app flex-row align-items-center">
        <Container>        
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup className="mb-0">
                <Card className="p-4">
                  <CardBody className="card-body">
                    <h1>Login</h1>
                    <p className="text-muted">Sign In to your account</p>
                    <form onSubmit={(e) => this.handleSubmit(e)} >

                    <InputGroup className="mb-3">
                      <InputGroupAddon><i className="icon-user"></i></InputGroupAddon>
                      <Input type="text" onChange={(e) => this.setInputState(e)} name="username" placeholder="Username"/>
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupAddon><i className="icon-lock"></i></InputGroupAddon>
                      <Input type="password" onChange={(e) => this.setInputState(e)} name="password" placeholder="Password"/>
                    </InputGroup>
                    <Row>
                      <Col xs="6">
                        {this.props.user.isLoading ? <Spinner align="left" /> : <Button color="primary" type="submit" className="px-4">Login</Button>}
                      </Col>
                      { /*<Col xs="6" className="text-right">
                          <Button color="link" className="px-0">Forgot password?</Button>
                       </Col>*/ }
                    </Row>
                    </form>
                  </CardBody>
                </Card>               
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {

    return {
        user: state.UserReducer,
        clientPath: state.clientPathReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (url, postData) => dispatch(userFetchData(url, postData))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/views/Login/Login.js